import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const lessonsApi = api
  .enhanceEndpoints({ addTagTypes: ["siigo"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      createInvoice: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/create/invoice`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      createVoucher: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/create/voucher`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      createExpense: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/create/expense`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),

      getClient: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/client/get`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      createClient: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/client/create`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      editClient: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/client/edit`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            color,
            description,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),

      generalConfig: builder.mutation({
        query: ({ branchId, name, color, description }: any) => ({
          url: `branchs/${branchId}/siigo/general/config`,
          method: RequestMethod.POST,
          body: camelToSnake({
            id: branchId,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      setConfig: builder.mutation({
        query: ({ branchId, ...rest  }: any) => ({
          url: `branchs/${branchId}/siigo/set/config`,
          method: RequestMethod.POST,
          body: camelToSnake({
            branch_id: branchId,
            ...rest,
          }),
        }),
        invalidatesTags: ["siigo"],
      }),
      getConfig: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/siigo/get/config`,
          method: RequestMethod.POST,
          body: camelToSnake({
            id: branchId,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
    }),
  });

export const {
  useCreateInvoiceMutation,
  useCreateVoucherMutation,
  useCreateExpenseMutation,
  useGetClientMutation,
  useCreateClientMutation,
  useEditClientMutation,
  useGeneralConfigMutation,
  useSetConfigMutation,
  useGetConfigQuery,
} = lessonsApi;
